var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-wrap"},[_c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._t("title")],2)]),_vm._t("content"),_c('div',{class:`declare ${_vm.type}`},[_vm._v(_vm._s(_vm.status))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }